import React from 'react'

const Detailsection = ({product}) => {
  return (
    <>
      <div>
        <div className='font-bold text-[30px]'>{product.title.shortTitle}</div>
        <div className=''>{product.title.longTitle}</div>
        
      </div>
    </>
  )
}

export default Detailsection
